import { networkAction } from "helpers/network/networkAction";

import {
  GET_LECTURES,
  GET_LECTURE_BY_ID,
  DELETE_LECTURE,
  UPDATE_LECTURE,
  CREATE_LECTURE,
} from "constants/lectures";

import * as Api from "api";

export const getLectures = () => async (dispatch) =>
  networkAction(dispatch, GET_LECTURES, Api.getLectures, []);

export const getLectureById = (id) => async (dispatch) =>
  networkAction(dispatch, GET_LECTURE_BY_ID, Api.getLectureById, [id]);

export const deleteLecture = (id) => async (dispatch) =>
  networkAction(dispatch, DELETE_LECTURE, Api.deleteLecture, [id]);

export const createLecture = (body) => async (dispatch) =>
  networkAction(dispatch, CREATE_LECTURE, Api.createLecture, [body]);

export const updateLecture = (id, body) => async (dispatch) =>
  networkAction(dispatch, UPDATE_LECTURE, Api.updateLecture, [id, body]);
